<template>
  <v-container fluid>
    <v-layout justify-center class="clsScroll">
      <v-data-table
        :headers="headers"
        :items="items"
        hide-actions
        disable-initial-sort
      >
        <template slot="headers" slot-scope="props">
          <tr>
            <th
              v-for="header in props.headers"
              :key="header.text"
              class="column sortable text-xs-center"
            >
              <span>{{ header.text }}</span>
            </th>
          </tr>
        </template>

        <template slot="items" slot-scope="props">
          <td
            :class="[
              'text-xs-center',
              props.item.id == transId ? 'missing-trans-pointer' : '',
            ]"
          >
            {{ props.index + 1 }}
          </td>

          <td
            :class="[
              'text-xs-center',
              props.item.id == transId ? 'missing-trans-pointer' : '',
            ]"
          >
            {{ props.item.trans_ticket_no ? props.item.trans_ticket_no : "--" }}
          </td>
          <td
            :class="[
              'text-xs-center',
              props.item.id == transId ? 'missing-trans-pointer' : '',
            ]"
          >
            {{ props.item.app ? props.item.app.toUpperCase() : "--" }}
          </td>
          <td
            :class="[
              'text-xs-center',
              props.item.id == transId ? 'missing-trans-pointer' : '',
            ]"
          >
            {{ props.item.card_no ? props.item.card_no : "--" }}
          </td>
          <td
            :class="[
              'text-xs-center',
              props.item.id == transId ? 'missing-trans-pointer' : '',
            ]"
          >
            {{ props.item.date ? props.item.date : "--" }}
          </td>
          <td
            :class="[
              'text-xs-center',
              props.item.id == transId ? 'missing-trans-pointer' : '',
            ]"
          >
            {{ props.item.time ? props.item.time : "--" }}
          </td>
          <td
            :class="[
              'text-xs-center',
              props.item.id == transId ? 'missing-trans-pointer' : '',
            ]"
          >
            {{
              props.item.transaction_type
                ? props.item.transaction_type.toUpperCase()
                : "--"
            }}
          </td>
          <td
            :class="[
              'text-xs-center',
              props.item.id == transId ? 'missing-trans-pointer' : '',
            ]"
          >
            {{
              props.item.prev_bal
                ? $amountInPeso(props.item.prev_bal)
                : $amountInPeso(0)
            }}
          </td>
          <td
            :class="[
              'text-xs-center',
              props.item.id == transId ? 'missing-trans-pointer' : '',
            ]"
          >
            {{
              props.item.amount
                ? $amountInPeso(props.item.amount)
                : $amountInPeso(0)
            }}
          </td>
          <td
            :class="[
              'text-xs-center',
              props.item.id == transId ? 'missing-trans-pointer' : '',
            ]"
          >
            {{
              props.item.remaining_bal
                ? $amountInPeso(props.item.remaining_bal)
                : $amountInPeso(0)
            }}
          </td>
        </template>
      </v-data-table>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  props: {
    data: Object,
    transId: String,
    items: Array,
    headers: Array,
    showSettle: Boolean,
    readOnly: Boolean,
  },
  data() {
    return {};
  },
  created() {},
  computed: {
    downloadData() {},
  },
  methods: {},
};
</script>

<style scoped>
.missing-trans-pointer {
  color: red;
  text-shadow: 0.5px 0.5px 0.5px darkred;
  font-size: 15px;
  background-color: #ebebeb;
}
.data-tab {
  border: 2px solid;
  border-collapse: collapse;
  width: 100%;
  margin-bottom: 20px;
  table-layout: fixed;
}
.data-tabletab {
  width: 100%;
}
.td1 {
  border: 2px solid;
  padding-right: 10px;
  padding-left: 10px;
}
.clsScroll {
  width: auto;
  overflow-x: auto;
  overflow-y: hidden;
}
input[type="text"] {
  display: inline-block;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}
select {
  padding: 12px 20px;
  margin: 8px 0;
  display: inline-block;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}
.uploading-image {
  display: flex;
}
.table-controls {
  padding: 0 !important;
}
table.v-table td,
th {
  box-shadow: 1px 0px 0px 0px #eee;
}
table.v-table tbody tr {
  cursor: pointer !important;
}
.current-row {
  background-color: #ddd;
}
.row-active {
  box-shadow: 4px -1px 0px 0px rgb(76, 175, 80) inset;
}
.row-inactive {
  color: rgb(244, 67, 54);
  box-shadow: 4px 0px 0px 0px rgb(244, 67, 54) inset;
}
table.v-table td,
th {
  height: 30px !important;
  padding: 0px 5px 0px 5px !important;
}
table.v-table thead tr:not(.v-datatable__progress) {
  height: 30px;
}
table.v-table th {
  padding-left: 5px !important;
  padding-right: 5px !important;
}
</style>
